import './gallery-product-item.css';
